const actions = {
  POST_SCHEDULE_CHANGE: 'POST_SCHEDULE_CHANGE',
  POST_SCHEDULE_CHANGE_SUCCESS: 'POST_SCHEDULE_CHANGE_SUCCESS',
  POST_SCHEDULE_CHANGE_ERROR: 'POST_SCHEDULE_CHANGE_ERROR',
  FETCH_KARIE_USER_SCHEDULES: 'FETCH_KARIE_USER_SCHEDULES',
  FETCH_KARIE_USER_SCHEDULES_SUCCESS: 'FETCH_KARIE_USER_SCHEDULES_SUCCESS',
  FETCH_KARIE_USER_SCHEDULES_ERROR: 'FETCH_KARIE_USER_SCHEDULES_ERROR',
  FETCH_SCHEDULE_CHANGES: 'FETCH_CHEDULE_CHANGES',
  FETCH_SCHEDULE_CHANGES_SUCCESS: 'FETCH_CHEDULE_CHANGES_SUCCESS',
  FETCH_SCHEDULE_CHANGES_ERROR: 'FETCH_SCHEDULE_CHANGES_ERROR',
  FETCH_PHARMACY_SCHEDULES: 'FETCH_PHARMACY_SCHEDULES',
  FETCH_PHARMACY_SCHEDULES_SUCCESS: 'FETCH_PHARMACY_SCHEDULES_SUCCESS',
  FETCH_PHARMACY_SCHEDULES_ERROR: 'FETCH_PHARMACY_SCHEDULES_ERROR',
  FETCH_SCHEDULE_DETAILS: 'FETCH_SCHEDULE_DETAILS',
  FETCH_SCHEDULE_DETAILS_SUCCESS: 'FETCH_SCHEDULE_DETAILS_SUCCESS',
  FETCH_SCHEDULE_DETAILS_ERROR: 'FETCH_SCHEDULE_DETAILS_ERROR',
  DELETE_SCHEDULE: 'DELETE_SCHEDULE',
  DELETE_SCHEDULE_SUCCESS: 'DELETE_SCHEDULE_SUCCESS',
  DELETE_SCHEDULE_ERROR: 'DELETE_SCHEDULE_ERROR',
  GET_CURRENT_TABLE_PAGE: 'GET_CURRENT_TABLE_PAGE',
  GET_CURRENT_DATE_RANGE: 'GET_CURRENT_DATE_RANGE',
  FROM_SCHEDULE_DETAILS_PAGE: 'FROM_SCHEDULE_DETAILS_PAGE',

  fetchKarieUserSchedules: (patientId, pharmacyId) => ({
    type: actions.FETCH_KARIE_USER_SCHEDULES,
    patientId,
    pharmacyId
  }),
  fetchPharmacySchedules: (clientId, startDate, endDate, pouchBarcode) => ({
    type: actions.FETCH_PHARMACY_SCHEDULES,
    clientId,
    startDate,
    endDate,
    pouchBarcode
  }),
  postScheduleChange: (scheduleId) => ({
    type: actions.POST_SCHEDULE_CHANGE,
    scheduleId
  }),
  fetchScheduleChanges: (scheduleId) => ({
    type: actions.FETCH_SCHEDULE_CHANGES,
    scheduleId
  }),
  fetchScheduleDetails: (scheduleId) => ({
    type: actions.FETCH_SCHEDULE_DETAILS,
    scheduleId
  }),
  deleteSchedule: (scheduleId) => ({
    type: actions.DELETE_SCHEDULE,
    scheduleId
  }),
  getCurrentTablePage: (page) => ({
    type: actions.GET_CURRENT_TABLE_PAGE,
    page
  }),
  getCurrentDateRange: (dateString, startDate, endDate) => ({
    type: actions.GET_CURRENT_DATE_RANGE,
    dateString,
    startDate,
    endDate
  }),
  checkScheduleDetailsPage: (check, page, dateString, pouchBarcode) => ({
    type: actions.FROM_SCHEDULE_DETAILS_PAGE,
    check,
    page,
    dateString,
    pouchBarcode
  })
};
export default actions;
